import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
export function extractAuthor(digest) {
  var sessionValidators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _digest$logs$filter = digest.logs.filter(function (_ref) {
    var type = _ref.type;
    return type === 'Consensus';
  }),
      _digest$logs$filter2 = _slicedToArray(_digest$logs$filter, 1),
      citem = _digest$logs$filter2[0];

  if (citem) {
    var _citem$asConsensus = _slicedToArray(citem.asConsensus, 2),
        engine = _citem$asConsensus[0],
        data = _citem$asConsensus[1];

    return engine.extractAuthor(data, sessionValidators);
  } else {
    var _digest$logs$filter3 = digest.logs.filter(function (_ref2) {
      var type = _ref2.type;
      return type === 'PreRuntime';
    }),
        _digest$logs$filter4 = _slicedToArray(_digest$logs$filter3, 1),
        pitem = _digest$logs$filter4[0];

    if (pitem) {
      var _pitem$asPreRuntime = _slicedToArray(pitem.asPreRuntime, 2),
          _engine = _pitem$asPreRuntime[0],
          _data = _pitem$asPreRuntime[1];

      return _engine.extractAuthor(_data, sessionValidators);
    }
  }

  return undefined;
}